// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 9385 ? "8c91c4ae" : chunkId) + "." + {"6700":"5347f0d30f17f501","9217":"7d573c86ce764976","9385":"9783b938e99fd7c6"}[chunkId] + ".js";
};